import React from "react";
import style from "./index.module.scss";
import { Radio } from "antd";
import { OptionItem, TopicsItem } from "../../../../../../../API/exercise";
import StuAnswerObj from "../../../Question/components/StuAnswerObj";

interface PageRadioProps {
    index?: number;
    data: TopicsItem;
    stuDoFlg: string;
}

export default function PageJudgeDetail({
    data,
    index,
    stuDoFlg
}: PageRadioProps) {
    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（判断题，{data.score}分）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>

            <div className={style.options}>
                <Radio.Group value={parseInt(data.stuAns)} disabled>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Radio
                                value={item.id}
                                key={index}
                                className={style.radioStyle}>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Radio>
                        ))}
                </Radio.Group>
            </div>
            <StuAnswerObj stuDoFlg={stuDoFlg} data={data} />
        </div>
    );
}
